import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useAdminAuth } from "@/admin/AdminAuthContext";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login, loading } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login fallito");
    }
  };

  return (
    <div className="min-h-screen bg-cream-50 grid place-items-center px-6">
      <div className="w-full max-w-md bg-white border border-cream-200 rounded-3xl p-8 md:p-10 shadow-soft">
        <p className="text-xs uppercase tracking-[0.25em] text-navy-700 font-semibold mb-3">Owner area</p>
        <h1 className="text-3xl font-extrabold text-slate-900 display-tight-2 mb-2">Accedi</h1>
        <p className="text-sm text-slate-600 mb-7">Area riservata · Attico Skyline Milano</p>
        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <span className="text-[10px] uppercase tracking-[0.18em] text-navy-700 font-semibold flex items-center gap-2 mb-2"><Mail size={12} /> Email</span>
            <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </label>
          <label className="block">
            <span className="text-[10px] uppercase tracking-[0.18em] text-navy-700 font-semibold flex items-center gap-2 mb-2"><Lock size={12} /> Password</span>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </label>
          {error && <p data-testid="admin-error" className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2">{error}</p>}
          <button data-testid="admin-submit" type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-navy-700 hover:bg-navy-800 disabled:opacity-60 text-white px-6 py-3.5 text-sm font-semibold transition-all">
            {loading ? <Loader2 size={16} className="animate-spin" /> : null}
            Entra
          </button>
        </form>
      </div>
    </div>
  );
}
